/**
 * 輕量級 SPA 歷史記錄與路徑控制器
 * 專為 WebGL Director 轉場管線設計
 */
export default class Router {
    constructor() {
        this.prev = null
        this.currentPath = this._parsePath()

        // 綁定 popstate 事件 handler 參照以便 destroy 移除
        this._onPopState = this._handlePopState.bind(this)
        window.addEventListener('popstate', this._onPopState)
    }

    /** 處理瀏覽器上一頁 / 下一頁 (popstate) */
    _handlePopState() {
        const newPath = this._parsePath()

        // 防呆：若路徑未變動則不處理
        if (this.currentPath === newPath) {
            return
        }

        this.prev = this.currentPath
        this.currentPath = newPath
        this.onChange?.(this.currentPath, 'popstate')
    }

    /**
     * 推入新的歷史記錄條目
     * @param {string} path - 目標相對路徑 (e.g. '/project/alpha')
     * @param {boolean} [silent=false] - 若為 true，僅更新 URL 與內部狀態，不觸發 onChange 回調（常用於 Director 已手動驅動動畫時）
     */
    push(path, silent = false) {
        if (this.currentPath === path) {
            return
        }

        this.prev = this.currentPath
        window.history.pushState({}, '', path)
        this.currentPath = path

        if (!silent) {
            this.onChange?.(this.currentPath, 'push')
        }
    }

    /**
     * 取代當前 history 條目（不新增歷史紀錄）
     * 用於應用程式初始化時正規化未支援或無效的路徑（例如 /about -> /）
     * @param {string} path - 目標路徑
     * @param {boolean} [silent=true] - 預設為 silent，避免觸發二次轉場
     */
    replace(path, silent = true) {
        if (this.currentPath === path) {
            return
        }

        this.prev = this.currentPath
        window.history.replaceState({}, '', path)
        this.currentPath = path

        if (!silent) {
            this.onChange?.(this.currentPath, 'replace')
        }
    }

    /** 從目前 window.location 解析標準化路徑 */
    _parsePath() {
        return window.location.pathname
    }

    /** 解除事件監聽（記憶體回收） */
    destroy() {
        window.removeEventListener('popstate', this._onPopState)
    }
}
